module.exports = __webpack_public_path__ + "rw-widgets.woff";


/*****************
 ** WEBPACK FOOTER
 ** ./src/styles/react-widgets/fonts/rw-widgets.woff?v=4.1.0
 ** module id = 571
 ** module chunks = 0
 **/